import React from "react";
import NewOrExistingAuth from "../../../common/basic_auth/NewOrExistingAuth";
import WizardSchedule from "../../../common/WizardSchedule";
import { alwaysTrue, objectTypeNameAndImportSourceMustNotBeEmpty } from "../../../../utils/wizardCommonValidations";
import GenericAssetConfig from "./pages/GenericAssetConfig";
import ConfirmGenericImport from "./pages/ConfirmGenericImport";
import webhook from "../../../../../icons/webhook-48.png"
import {userNamePasswordNotEmpty} from "../../assets_wizard_validations"
import GenericWebRequest from "./pages/GenericWebRequest";
const wizard = {
  title: "Assets Generic API Import",
  id: "JSM_ASSETS_GENERIC_IMPORT",
  description: "Import from any REST API into Assets",
  category: "JSM_ASSET_IMPORT",
  icon: <img src={webhook} width={40} height={40}/>,
  pages: [
    {
      id: "1",
      label: "Credentials",
      percentageComplete: 0,
      status: "visited",
      href: "#",
      content: <NewOrExistingAuth info="Credentials are required for the app to read users and create asset import configurations."/>,
      validate: userNamePasswordNotEmpty
    }, 
    {
      id: "2",
      label: "Import Configuration",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <GenericAssetConfig />,
      validate: objectTypeNameAndImportSourceMustNotBeEmpty,
    },  {
      id: "3",
      label: "Web Request",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <GenericWebRequest />,
      validate: alwaysTrue,
    },
    {
      id: "4",
      label: "Schedule",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <WizardSchedule />,
      validate: alwaysTrue
    }, 
    {
      id: "5",
      label: "Summary",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <ConfirmGenericImport />,
      validate: alwaysTrue

    }
  ],
};
export default wizard;
